const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEKDAYS = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];

function startOfDay(d: Date) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

function daysBetween(from: Date, to: Date) {
  return Math.round((startOfDay(to) - startOfDay(from)) / DAY);
}

const pad = (n: number) => String(n).padStart(2, '0');

export function clockTime(iso: string) {
  const d = new Date(iso);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Thời gian trên post/bình luận: "Vừa xong", "12 phút", "3 giờ", "Hôm qua", "20/10". */
export function relativeTime(iso: string, now = new Date()) {
  const date = new Date(iso);
  const diff = now.getTime() - date.getTime();
  if (diff < MINUTE) return 'Vừa xong';
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)} phút`;
  const days = daysBetween(date, now);
  if (days === 0) return `${Math.floor(diff / HOUR)} giờ`;
  if (days === 1) return 'Hôm qua';
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}`;
}

/** Thời gian ở danh sách chat: "20:14", "Hôm qua", "T2", "20/10". */
export function chatListTime(iso: string, now = new Date()) {
  const date = new Date(iso);
  const days = daysBetween(date, now);
  if (days === 0) return clockTime(iso);
  if (days === 1) return 'Hôm qua';
  if (days < 7) return WEEKDAYS[date.getDay()];
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}`;
}

/** Nhãn ngày chia cụm tin nhắn: "Hôm nay", "Hôm qua", "20/10". */
export function dayLabel(iso: string, now = new Date()) {
  const date = new Date(iso);
  const days = daysBetween(date, now);
  if (days === 0) return 'Hôm nay';
  if (days === 1) return 'Hôm qua';
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}`;
}

/// Tên gọi trong header "Bài của Bảo" và dòng tin cuối — tên Việt là từ cuối của họ tên.
export function shortName(name: string) {
  return name.trim().split(' ').pop() ?? name;
}
